import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { useSourceMix } from "../hooks/useOcrHealthData";
import { SOURCE_COLORS } from "../sourceColors";
import { PanelCard, PanelError, PanelStatus } from "./PanelCard";

export function SourceMixDonut() {
  const { data, isLoading, error } = useSourceMix(30);

  if (isLoading) return <PanelCard title="Source Mix (last 30d)"><PanelStatus>Loading…</PanelStatus></PanelCard>;
  if (error) return <PanelCard title="Source Mix (last 30d)"><PanelError>Couldn't load — {error}</PanelError></PanelCard>;
  if (!data || data.totalFields === 0) {
    return (
      <PanelCard title="Source Mix (last 30d)">
        <PanelStatus>No OCR extractions yet</PanelStatus>
      </PanelCard>
    );
  }

  const chartData = data.buckets
    .filter((b) => b.count > 0)
    .map((b) => ({ name: b.source, value: b.count, percent: b.percent }));

  return (
    <PanelCard title="Source Mix (last 30d)">
      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={56}
            outerRadius={96}
            paddingAngle={2}
            isAnimationActive={false}
          >
            {chartData.map((entry) => (
              <Cell key={entry.name} fill={SOURCE_COLORS[entry.name] ?? "#999"} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name, item) => {
              const percent = (item?.payload as { percent?: number } | undefined)?.percent ?? 0;
              return [`${value} (${(percent * 100).toFixed(1)}%)`, String(name)];
            }}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </PanelCard>
  );
}
